import { render, staticRenderFns } from "./VueDataTableUtilItem.vue?vue&type=template&id=7e4c149a&scoped=true"
import script from "./VueDataTableUtilItem.vue?vue&type=script&lang=js"
export * from "./VueDataTableUtilItem.vue?vue&type=script&lang=js"
import style0 from "./VueDataTableUtilItem.vue?vue&type=style&index=0&id=7e4c149a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c149a",
  null
  
)

export default component.exports